import Tasks from 'APP/Tasks';
import Entities from 'STORE';

export function clearInputPanel(groupId: string, clearInput = true): void {
  const inputPanel = Entities.InputPanelsStore.getById(groupId);

  if (!inputPanel) {
    return;
  }

  if (clearInput) {
    inputPanel.setValue(null);
    inputPanel.setEditMessageId(null);
    Tasks.messaging.resetLinkPreviewProcess(groupId);
    inputPanel.mention.reset();
  }

  if (inputPanel.replyMessage) {
    inputPanel.setReplyMessage(null);
  }

  if (inputPanel.quote) {
    inputPanel.setQuote(null);
  }

  inputPanel.voice.reset();
}
